<div class="ec" [attr.data-variant]="variant" [attr.data-tone]="card.tone || 'violet'">
  <span class="ec__icon" aria-hidden="true">
    <app-eco-icon [name]="card.icon"></app-eco-icon>
  </span>

  <span class="ec__text">
    <strong class="ec__title">{{ card.title }}</strong>
    <small class="ec__desc">{{ card.desc }}</small>
  </span>
</div>
